import { Check } from "lucide-react";

export const CarStepper = ({ steps, current, onJump }) => (
  <div className="flex items-center gap-1 sm:gap-2" data-testid="car-stepper">
    {steps.map((label, i) => {
      const n = i + 1;
      const done = n < current;
      const active = n === current;
      return (
        <div key={label} className="flex items-center gap-1 sm:gap-2 flex-1 last:flex-none">
          <button
            onClick={() => (done || active) && onJump?.(n)}
            disabled={!done && !active}
            className={`flex items-center gap-2 rounded-full pl-1.5 pr-3 py-1.5 text-xs font-mono transition-colors ${
              active ? "bg-primary/15 text-primary" : done ? "text-foreground hover:bg-muted" : "text-muted-foreground"
            }`}
            data-testid={`car-step-${n}`}
          >
            <span className={`h-6 w-6 rounded-full grid place-items-center text-[11px] font-semibold ${
              active ? "bg-primary text-primary-foreground" : done ? "bg-primary/20 text-primary" : "bg-muted text-muted-foreground"
            }`}>
              {done ? <Check size={13} strokeWidth={3} /> : n}
            </span>
            <span className="hidden sm:inline">{label}</span>
          </button>
          {n < steps.length && <div className={`h-px flex-1 ${done ? "bg-primary/40" : "bg-border"}`} />}
        </div>
      );
    })}
  </div>
);
